// Mock data for Trevora Travel

export const BRAND = {
  name: "TREVORA",
  tagline: "Beyond Travel, Into Stories.",
  phone: "+91 90980 26726",
  phoneRaw: "9098026726",
  whatsapp: "919098026726",
  email: "info@trevora.co.in",
  address: "Gurugram, Haryana, India",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_trevora-staging/artifacts/qerkl1yo_IMG_9500.png",
};

export const HERO_WORDS = ["Dream", "Memory", "Story", "Adventure"];

export const LOCATIONS = [
  "Kerala", "Himachal", "Rajasthan", "Kashmir", "Goa", "Uttarakhand",
  "Nepal", "Bhutan", "Maldives", "Dubai",
];

export const STATS = [
  { label: "Customized Itineraries", value: "500+" },
  { label: "Happy Travelers", value: "18,000+" },
  { label: "Destinations Covered", value: "40+" },
  { label: "Support Available", value: "24×7" },
];

export const INTERNATIONAL = [
  { name: "Nepal", price: "₹18,999", image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800&q=80", slug: "nepal" },
  { name: "Bhutan", price: "₹32,500", image: "https://images.unsplash.com/photo-1553856622-d1b352e9a211?w=800&q=80", slug: "bhutan" },
  { name: "Maldives", price: "₹45,000", image: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=800&q=80", slug: "maldives" },
  { name: "Dubai", price: "₹55,000", image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80", slug: "dubai" },
];

export const DOMESTIC = [
  { name: "Rajasthan", image: "https://images.unsplash.com/photo-1661924326425-c14a6426d989?w=800&q=80", slug: "rajasthan" },
  { name: "Goa", image: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=800&q=80", slug: "goa" },
  { name: "Kerala", image: "https://images.unsplash.com/photo-1593693411515-c20261bcad6e?w=800&q=80", slug: "kerala" },
  { name: "Himachal", image: "https://images.unsplash.com/photo-1578048117504-495014256835?w=800&q=80", slug: "himachal" },
  { name: "Kashmir", image: "https://images.unsplash.com/photo-1564329494258-3f72215ba175?w=800&q=80", slug: "kashmir" },
];

export const TOP_TOURS = [
  {
    title: "Bliss Kerala – 4N / 5D Tour",
    nights: "4 Nights",
    days: "5 Days",
    price: "₹14,999",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=900&q=80",
    tag: "Featured",
  },
  {
    title: "Blissful Kashmir – 5 Days Tour",
    nights: "4 Nights",
    days: "5 Days",
    price: "₹15,999",
    image: "https://images.pexels.com/photos/35255985/pexels-photo-35255985.jpeg?auto=compress&w=900",
    tag: "Featured",
  },
  {
    title: "Coorg & Ooty – 5N / 6D Tour",
    nights: "5 Nights",
    days: "6 Days",
    price: "₹15,999",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=900&q=80",
    tag: "Featured",
  },
  {
    title: "Magical Bali – 6N / 7D Escape",
    nights: "6 Nights",
    days: "7 Days",
    price: "₹29,999",
    image: "https://images.unsplash.com/photo-1576475706812-822620fc23ba?w=900&q=80",
    tag: "Bestseller",
  },
  {
    title: "Dubai Delights – 4N / 5D Tour",
    nights: "4 Nights",
    days: "5 Days",
    price: "₹34,999",
    image: "https://images.unsplash.com/photo-1572364769167-198dcb7b520c?w=900&q=80",
    tag: "Featured",
  },
];

export const THEMES = [
  { name: "Honeymoon", image: "https://images.unsplash.com/photo-1519307212971-dd9561667ffb?w=800&q=80" },
  { name: "Beach", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80" },
  { name: "Pilgrimage", image: "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&q=80" },
  { name: "Adventure", image: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=800&q=80" },
  { name: "Family", image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800&q=80" },
  { name: "Luxury", image: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=800&q=80" },
];

export const VISA_FREE = [
  { name: "Nepal", price: "18,999", image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800&q=80" },
  { name: "Bhutan", price: "32,500", image: "https://images.unsplash.com/photo-1553856622-d1b352e9a211?w=800&q=80" },
  { name: "Sri Lanka", price: "28,999", image: "https://images.unsplash.com/photo-1588598198321-9735fd52455b?w=800&q=80" },
  { name: "Maldives", price: "45,000", image: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=800&q=80" },
];

export const SPIRITUAL_TOURS = [
  {
    title: "Char Dham Yatra – 11N / 12D",
    nights: "11 Nights", days: "12 Days", price: "₹32,999",
    image: "https://images.unsplash.com/photo-1612438214708-f428a707dd4e?w=900&q=85",
    tag: "Kedarnath",
  },
  {
    title: "Char Dham Yatra – 9N / 10D",
    nights: "9 Nights", days: "10 Days", price: "₹28,499",
    image: "https://images.unsplash.com/photo-1601821139314-66a4d14cfc00?w=900&q=85",
    tag: "Badrinath",
  },
  {
    title: "Char Dham by Helicopter – 5N / 6D",
    nights: "5 Nights", days: "6 Days", price: "₹2,00,000",
    image: "https://images.pexels.com/photos/15031440/pexels-photo-15031440.jpeg?auto=compress&w=900",
    tag: "Premium",
  },
];

export const BUDGET_TIERS = [
  { label: "Under ₹15,000", tag: "Budget", image: "https://images.unsplash.com/photo-1528181304800-259b08848526?w=800&q=80" },
  { label: "₹15,000 – ₹30,000", tag: "Value", image: "https://images.unsplash.com/photo-1593693411515-c20261bcad6e?w=800&q=80" },
  { label: "₹30,000 – ₹60,000", tag: "Comfort", image: "https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=800&q=80" },
  { label: "₹60,000 – ₹1,00,000", tag: "Premium", image: "https://images.unsplash.com/photo-1572364769167-198dcb7b520c?w=800&q=80" },
  { label: "Above ₹1,00,000", tag: "Luxury", image: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=800&q=80" },
];

export const TESTIMONIALS = [
  {
    name: "Poonam Jain",
    tags: ["Group Tour", "Dubai"],
    text: "Our Dubai trip with Trevora was flawless — desert safari, Burj Khalifa, and even a surprise dhow cruise dinner. Everything was punctual, warm and beautifully organised.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80",
  },
  {
    name: "Rahul & Meera Sharma",
    tags: ["Honeymoon", "Maldives"],
    text: "Our Maldives honeymoon was a dream — overwater villa, candle-lit dinners and gorgeous sunsets. Trevora took care of every tiny detail so we only had to enjoy.",
    avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&q=80",
  },
  {
    name: "Anita Verma",
    tags: ["Family", "Kashmir"],
    text: "Kashmir with our kids and parents felt effortless. Verified houseboats, safe drivers and a thoughtful itinerary made it the smoothest family holiday we've had.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80",
  },
  {
    name: "Aditya Menon",
    tags: ["Solo", "Nepal"],
    text: "Did a 7-day Nepal solo trip planned by Trevora — Pokhara, Kathmandu and a Himalayan sunrise at Nagarkot. Great local guides and instant help whenever I needed it.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80",
  },
];

export const WHY_US = [
  { title: "One stop, zero hassle", desc: "Stays, transport, guides and tour leaders — we manage every detail so you can just enjoy the journey." },
  { title: "Transparent pricing", desc: "Book direct, skip hidden fees. Enjoy honest prices and personalised planning — no confusion, only clarity." },
  { title: "Solo-friendly, always", desc: "Travelling alone? You are safe with us. Verified stays and vetted local partners, especially for women travellers." },
  { title: "Verified stays & rides", desc: "Every hotel, cab and guide is checked for comfort and safety. No surprises — just peace of mind everywhere you go." },
];
